module.exports = __webpack_public_path__ + "static/netflix-5b86af6e44b60f1a37f1fa7abb33fbd0.png";